/**
 * Bus
 * (c) Les Affranchis - 2009-2021
 *
 * Author - Martin Tremblay - martin@lesaffranchis.ca
 *
 * Goal: A small state management/event dispatcher for the Vimy - Living Memorial Vivant project
 */

import BusEvent          from "./BusEvent.js";
import {TUTORIAL_EVENTS} from "./BusEvent.js";
import AudioManager      from "./AudioManager.js";
import _                 from "lodash";

export default class Bus
{
    static get instance()
    {
        return Bus.m_instance;
    }
    
    static set instance(inst)
    {
        Bus.m_instance = inst;
    }
    
    static get CONTEXT()
    {
        return {
            BREADCRUMBS_CLICK: "BREADCRUMBS_CLICK",
        }
    }
    
    
    constructor()
    {
        if (Bus.instance)
        {
            console.log("%cDon't instantiate the Bus Class. Use Bus.instance instead", "padding:25px; background-color:red;");
            return;
        }
        
        Bus.instance = this;
        
        
        this.listenToEvents();
        
        this.isReady = false;
        
        this.arrWaitBeforeReady = [BusEvent.EVENTS.READY_2D, BusEvent.EVENTS.READY_3D];
        
        this.langIsSet = false;
        this.listeningToPaperReturnedToVortex = false;
        this.data = {};
        this.copydeck = {};
        this.state = {};
        this.sessionState = {currentGroup: [], hasAskedToShare: false};
        
        this.arrOnce = [];
        this.bChangedRate = false;
        this.strContext = "";
        this.testimonialActive = false;
        this.isFinished = false;
        
        this.lang = "fr";
        
        this.config =
            {
                showShareAfterXThemeCount: 2,
            };
        
        
        this.prepareAudio();
        
        
    }
    
    get isIOS()
    {
        const ua = navigator.userAgent;
        
        if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
        {
            return true;
        }
        return false
    }
    
    prepareAudio()
    {
        
        let strFile = this.isIOS ? "/_/audios/audio-lite.json" : "/_/audios/audio.json";
        
        let responseJsonAudioSprite = fetch(strFile).then((response) =>
                                                                         {
                                                                             response.json().then((json) =>
                                                                                                  {
                                                                                                      this.onAudioFormatReady(json);
                                                                                                  })
                                                                             //let jsonAudioSprite = await responseJsonAudioSprite.json();
            
                                                                             //console.log(jsonAudioSprite);
                                                                         });
        
    }
    
    onAudioFormatReady(json)
    {
        this.audioManager = new AudioManager(json);
        
    }
    
    onPlaySound(event)
    {
        console.log("onPLaySound", event);
        
        if (!event.options.delay)
        {
            this.playSound(event.options.key, event.options.loop ?? false, event.options.group ?? (Math.random() * 0x999999).toString());
        }
        else
        {
            setTimeout(() => this.playSound(event.options.key,
                                            event.options.loop ?? false,
                                            event.options.group ?? (Math.random() * 0x999999).toString()), event.options.delay);
        }
    }
    
    playSound(key, loop = false, group = "")
    {
        console.log("Bus", key);
        this.audioManager.playSound(key, loop, group);
    }
    
    muteSound(soundId, key, group, fadeSpeed)
    {
        this.audioManager.muteSound(soundId, key, group, fadeSpeed);
    }
    
    unmuteSound(soundId, key, group, fadeSpeed)
    {
        this.audioManager.unmuteSound(soundId, key, group, fadeSpeed);
    }
    
    listenToEvents()
    {
        let arrIgnore = [BusEvent.EVENTS.RECEIVE, BusEvent.EVENTS.BROADCAST, BusEvent.EVENTS.READY];
        let allEvents = Object.values(BusEvent.EVENTS).filter(e => !arrIgnore.includes(e));
        
        allEvents.forEach((strEvent) =>
                          {
                              document.addEventListener(strEvent, this.onReceive.bind(this))
                          });
    }
    
    
    broadcast(strEvent, options = {})
    {
        let event = typeof (strEvent) === "string" ? new BusEvent(strEvent, options) : this.cloneEvent(strEvent);
        
        console.log("%cBus is dispatching", event.type, options, event);
        
        event.options.rebroadcast = false;
        event.options.broadcastAt = Date.now();
        document.dispatchEvent(event)
        
        
        if (event.type === BusEvent.EVENTS.TESTIMONIAL_CLOSED)
        {
            this.onTestimonialClosed();
        }
        
        //MT: For now I remove this since it only useful to debug
        //document.dispatchEvent(new BusEvent(BusEvent.EVENTS.BROADCAST, {event}))
    }
    
    cloneEvent(event)
    {
        let options = {...event.options};
        options.rebroadcast = false;
        
        return new BusEvent(event.type, options);
    }
    
    onReceive(event)
    {
        console.log("onReceive", event.type);
        // if (!this.checkBlame(event))
        //     return;
        //Remove
        let arrOnce = this.arrOnce.filter(o => o.event === event.type);
        this.arrOnce = this.arrOnce.filter(o => o.event !== event.type);
        
        for (let i = 0; i < arrOnce.length; i++)
        {
            let callback = arrOnce[i].callback;
            callback(event);
        }
        
        
        let shouldHandleEvent = (event.options === undefined) || (event.options.rebroadcast === undefined) || event.options.rebroadcast;
        
        let arrEventsNoConsole = [BusEvent.EVENTS.CURSOR_CLICK_3D, BusEvent.EVENTS.CURSOR_HOVER_3D];
        
        if (!arrEventsNoConsole.includes(event.type))
        {
            console.log(shouldHandleEvent, event);
        }
        
        if (shouldHandleEvent)
        {
            //MT: For now I remove this since it only useful to debug
            //document.dispatchEvent(new BusEvent(BusEvent.EVENTS.RECEIVE, {event}));
            
            
            if (this.checkIfReady(event))
            {
                this.handleReceivedEvent(event);
            }
            else
            {
                //Some event might habe to be handle event when the state is not ready
                this.handleAnyStateEvent(event);
            }
            
        }
        
    }
    
    
    checkIfReady(event)
    {
        if (this.isReady)
        {
            return true;
        }
        
        if (!this.checkBlame(event))
        {
            return false;
        }
        
        //if we are waiting for this event, we remove it from the waiting array
        this.arrWaitBeforeReady = this.arrWaitBeforeReady.filter(e => e !== event.type);
        
        this.isReady = this.arrWaitBeforeReady.length === 0;
        
        //all we are waiting for is ready
        if (this.isReady)
        {
            console.log("%c    READY    ", "background-color:green; padding: 10px; color:white;")
            let options = {...this.data};
            options.rebroadcast = false;
            
            this.broadcast(BusEvent.EVENTS.READY, options);
            
            if (this.langIsSet)
            {
                this.sendInitialThemes();
            }
        }
        else
        {
            console.log("%cNot ready yet : " + event.type, "background-color:orange")
        }
        
        return this.isReady;
        
        
    }
    
    
    getCurrentThemesByName()
    {
        if (this.sessionState.currentGroup.length === 0) //if we continue but all theme have been seen
        {
            let theme = this.data.themes.find(a => a);
            this.sessionState.currentGroup = [theme.id];
            this.state.visitedThemes = this.state.visitedThemes.filter(t => t !== theme.id);
        }
        
        let groups = this.sessionState.currentGroup;
        
        let themes = this.getThemesNameAndId(this.data.themes.filter(t => groups.includes(t.id)))
        
        //when we are reaching the end, we will send 3 anyway but with empty space
        if (themes.length === 0)
        {
            
            // if (themes.length === 1)
            // {
            //     themes.shift(null);
            //     themes.push(null);
            // }
            // else
            // {
            //     let last = themes.pop();
            //     themes.push(null);
            //     themes.push(last);
            // }
        }
        
        return themes;
        
        
    }
    
    getThemesNameAndId(themes)
    {
        return themes.map(t => ({id: t.id, title: t.title[this.lang].toUpperCase()}))
    }
    
    
    checkBlame(event)
    {
        return true;
        
        //if (event instanceof BusEvent)
        if (event.hasOwnProperty('options'))
        {
            return true;
        }
        
        if (!event)
        {
            console.error("Event is not defined :", event);
            return false;
        }
        
        console.error("Event should be of class BusEvent, but is of type :", event);
        
        if (event.type)
        {
            console.log(`%cEvent Type ${event.type} cannot be handle.`, "background-color:red;");
        }
        
        return false;
        
    }
    
    
    onSetCurrentTheme(event)
    {
        console.log("%cSET CURRENT THEME", "background-color:pink; padding: 20px; font-size: 15px;")
        console.log("onSetCurrentTheme", event.options.id);
        
        let theme = this.data.themes.find(t => t.id === event.options.id);
        
        //making sure that visited testimonial are track as viewed
        theme.testimonials.forEach(t =>
                                   {
                                       t.view = this.state.visitedTestimonals.includes(t.id)
                                   })
        
        theme.testimonials = theme.testimonials.filter( t => t.langs.includes(this.lang))
        theme.testimonials = theme.testimonials.sort((a, b) => (a.view === b.view) ? 0 : (a.view < b.view ? -1 : 1));
        
        this.state.currentTheme = this.getThemeInfo(theme);
        
        if (this.sessionState.currentGroup.length > 0 /*1*/) //we want to keep the last theme available to avoid a context where no statue is displayed
        {
            this.state.visitedThemes.push(theme.id);
            this.sessionState.currentGroup = this.sessionState.currentGroup.filter(t => t !== theme.id);
        }
        
        this.sendGtagEvent("Theme", theme.title);
        
        this.saveState();
        
        
        this.onGetVisitedThemes();
        
        console.log("onSetCurrentTheme", this.sessionState.currentGroup);
        
        
    }
    
    getThemeInfo(theme)
    {
        let viewTestimonial = theme.testimonials.reduce(t => this.state.visitedThemes.includes(t.id) ? 1 : 0, 0);
        
        return {
            id:               theme.id,
            title:            theme.title,
            totalTestimonial: Math.max((theme.testimonials ?? []).length, 1),//since total will be used to divided we want to avoid zero
            viewTestimonial,
        }
    }
    
    /**
     * ***********************************************
     * BELOW ARE THE REALLY PROJECT SPECIFIC METHODS *
     * ***********************************************
     */
    handleReceivedEvent(event)
    {
        // if (!this.checkBlame(event))
        //     return;
        
        let fctStop = function ()
        {
        };
        let fctRebroadcast = this.broadcastWithNewType.bind(this);
        let fctOnCopydeck = this.onData.bind(this, "copydeck");
        let fctOnData = this.onData.bind(this, "data");
        let fctChangeTheme = this.onSetCurrentTheme.bind(this);
        let fctOnTestimonialIsReadyToBeDisplayed = this.onTestimonialIsReadyToBeDisplayed.bind(this);
        let fctOnTestimonialIsOffscreen = this.onTestimonialIsOffscreen.bind(this);
        let fctOnShareTestimonialVisibility = this.onShareTestimonialVisibility.bind(this);
        let fctOnShowNewThemes = this.onShowNewThemes.bind(this);
        let fctOnClickBreadcrumbs = this.onClickBreadcrumbs.bind(this);
        let fctOnLang = this.onSetLang.bind(this);
        let fctOnGetVisitedThemes = this.onGetVisitedThemes.bind(this);
        let fctOnPaperReturnedToVortex = this.onPaperReturnedToVortex.bind(this);
        let fctOnNewThemesShown = this.onNewThemeShown.bind(this);
        let fctOnHover = this.onHover3D.bind(this);
        let fctOnClick = this.onClick3D.bind(this);
        let fctOnStartFinishExperience = this.onStartFinishExperience.bind(this);
        let fctOnShowCredits = this.onShowCredits.bind(this);
        let fctOnClickThemePrevNext = this.onShowPrevNextTheme.bind(this);
        let fctGetThemePrevNext = this.onGetPrevNextTheme.bind(this);
        let fctOnShareTestimonialClosed = this.onShareTestimonialClosed.bind(this);
        let fctLaunchTutorial = this.onLaunchTutorial.bind(this);
        let fctOnVortexReady = this.onVortexReady.bind(this);
        let fctOnPlaySound = this.onPlaySound.bind(this);
        let fctOnShareTestimonial = this.onShareTestimonial.bind(this);
        let fctOnCloseTutorial = this.onCloseTutorial.bind(this);
        let fctOnResetState = this.onResetState.bind(this);
        let fctOnShowFog = this.onShowFog.bind(this);
        
        let arrClosure =
                [
                    {event: BusEvent.EVENTS.READY_2D, fct: fctStop},
                    {event: BusEvent.EVENTS.READY_3D, fct: fctStop},
                
                    {event: BusEvent.EVENTS.INTRO_STEP, fct: fctRebroadcast},
                    {event: BusEvent.EVENTS.INTRO_COMPLETE, fct: fctRebroadcast},
                    {event: BusEvent.EVENTS.SHOW_OTHER_THEMES, fct: fctOnShowNewThemes},
                    {event: BusEvent.EVENTS.TESTIMONIAL_IS_OFFSCREEN, fct: fctOnTestimonialIsOffscreen},
                
                    {event: BusEvent.EVENTS.CHANGE_THEME, fct: fctChangeTheme},
                    {event: BusEvent.EVENTS.COPYDECK, fct: fctOnCopydeck},
                    {event: BusEvent.EVENTS.DATA, fct: fctOnData},
                
                    {event: BusEvent.EVENTS.PAPER_OUT_OF_SCREEN, fct: fctOnTestimonialIsReadyToBeDisplayed},
                    {event: BusEvent.EVENTS.OTHER_THEMES_REQUESTED, fct: fctOnShowNewThemes},
                    {event: BusEvent.EVENTS.PAPER_RETURNED_TO_VORTEX, fct: fctOnPaperReturnedToVortex},
                    {event: BusEvent.EVENTS.NEW_THEMES_SHOWN, fct: fctOnNewThemesShown},
                    {event: BusEvent.EVENTS.LANG, fct: fctOnLang},
                    {event: BusEvent.EVENTS.GET_VISITED_THEMES, fct: fctOnGetVisitedThemes},
                    {event: BusEvent.EVENTS.SHARE_TESTIMONIAL_VISIBILITY, fct: fctOnShareTestimonialVisibility},
                    {event: BusEvent.EVENTS.CLICK_BREADCRUMBS, fct: fctOnClickBreadcrumbs},
                    {event: BusEvent.EVENTS.SHARE_TESTIMONIAL_CLOSED, fct: fctOnShareTestimonialClosed},
                
                
                    {event: BusEvent.EVENTS.CURSOR_HOVER_3D, fct: fctOnHover},
                    {event: BusEvent.EVENTS.CURSOR_CLICK_3D, fct: fctOnClick},
                
                
                    {event: BusEvent.EVENTS.FINISH_EXPERIENCE, fct: fctOnStartFinishExperience},
                    {event: BusEvent.EVENTS.END_VORTEX_SHOWN, fct: fctOnShowCredits},
                    {event: BusEvent.EVENTS.CLICK_THEME_PREV_NEXT, fct: fctOnClickThemePrevNext},
                    {event: BusEvent.EVENTS.GET_THEME_PREV_NEXT, fct: fctGetThemePrevNext},
                    {event: BusEvent.EVENTS.LAUNCH_TUTORIAL, fct: fctLaunchTutorial},
                    {event: BusEvent.EVENTS.ON_VORTEX_READY, fct: fctOnVortexReady},
                    {event: BusEvent.EVENTS.PLAY_SOUND, fct: fctOnPlaySound},
                    {event: BusEvent.EVENTS.ON_SHARE_TESTIMONIAL, fct: fctOnShareTestimonial},
                    {event: BusEvent.EVENTS.CLOSE_TUTORIAL, fct: fctOnCloseTutorial},
                    {event: BusEvent.EVENTS.RESET_STATE, fct: fctOnResetState},
                    {event: BusEvent.EVENTS.SHOW_FOG, fct: fctOnShowFog},
                ];
        
        
        let cl = arrClosure.find(c => c.event === event.type);
        
        if (cl)
        {
            cl.fct(event);
            return;
        }
        
        //if we have no specific methods to call, we dispatch it to document
        if (event.options.rebroadcast ?? true)
        {
            this.broadcast(event);
        }
    }
    
    handleAnyStateEvent(event)
    {
        let strType = event.type;
        
        let arrAnyStateEvent = [BusEvent.EVENTS.DATA, BusEvent.EVENTS.COPYDECK, BusEvent.EVENTS.LANG];
        
        if (arrAnyStateEvent.includes(strType))
        {
            this.handleReceivedEvent(event);
        }
    }
    
    
    broadcastWithNewType(event)
    {
        if (!this.checkBlame(event))
        {
            return;
        }
        
        let objLUT = {}
        objLUT[BusEvent.EVENTS.INTRO_STEP] = BusEvent.EVENTS.ON_INTRO_STEP;
        objLUT[BusEvent.EVENTS.INTRO_COMPLETE] = BusEvent.EVENTS.ON_INTRO_COMPLETE;
        objLUT[BusEvent.EVENTS.PAPER_OUT_OF_SCREEN] = BusEvent.EVENTS.TESTIMONIAL_READY_TO_SLIDE_IN;
        objLUT[BusEvent.EVENTS.SHOW_OTHER_THEMES] = BusEvent.EVENTS.OTHER_THEMES_REQUESTED;
        //objLUT[BusEvent.EVENTS.SHOW_FOG] = BusEvent.EVENTS.ON_SHOW_FOG;
        //objLUT[BusEvent.EVENTS.TESTIMONIAL_IS_OFFSCREEN] = BusEvent.EVENTS.RETURN_PAPER_TO_VORTEX;
        objLUT[BusEvent.EVENTS.OUTRO_2D_FINISHED] = BusEvent.EVENTS.SHOW_END_CREDITS;
        
        
        let newEvent = new BusEvent(objLUT[event.type], event.options);
        
        this.broadcast(newEvent);
        
        
        if (event.type === BusEvent.EVENTS.INTRO_STEP)
        {
            this.onIntroStep(event.options);
            
        }
        else if (event.type === BusEvent.EVENTS.INTRO_COMPLETE)
        {
            this.onIntroComplete(event.options);
        }
        
        
    }
    
    
    onData(strDataType, event)
    {
        
        if (strDataType === "copydeck")
        {
            this.copydeck = event.options;
        }
        else if (strDataType === "data")
        {
            this.data = event.options;
            
            this.prepareState();
        }
        
        console.log("onDataType", arguments)
    }
    
    onCloseTutorial()
    {
        this.closeTutorial();
    }
    
    onResetState()
    {
        this.state = this.getDefaultState();
        this.saveState();
        
        this.prepareCurrentGroup();
        
        this.sendInitialThemes();
    }
    
    onShowFog (event)
    {
        if (this.isFinished)
            return;
        
        let newEvent = new BusEvent(BusEvent.EVENTS.ON_SHOW_FOG, event.options);
    
        this.broadcast(newEvent);
    }
    
    onClickBreadcrumbs(e)
    {
        
        let themeIndex = e.options.theme;
        let theme = this.data.themes.find(t => t.id === themeIndex);
        
        let objTheme = this.getThemesNameAndId([theme]);
        
        theme = objTheme.pop();
        
        let options = {visibility: false};
        this.broadcast(BusEvent.EVENTS.SHOW_SPECIFIC_THEME, {theme})
        this.broadcast(BusEvent.EVENTS.BREADCRUMB_VISIBILITY, options)
        this.broadcast(BusEvent.EVENTS.THEMES_SELECTION_DISPLAYED, options);
        this.broadcast(BusEvent.EVENTS.CHANGE_THEME, {id: theme.id})
        
        this.strContext = Bus.CONTEXT.BREADCRUMBS_CLICK;
        this.onSetCurrentTheme({options: {id: theme.id}})
        
        this.sendGtagEvent("Theme", theme.title[this.lang]);
        this.sendGtagEvent("Breadcrumbs", theme.title[this.lang]);
        
        this.closeTutorial()
        
    }
    
    sendGtagEvent(strEvent, props)
    {
        if (!window.gtag)
        {
            return;
        }
        
        if (props)
        {
            window.gtag('event', strEvent, props)
        }
        else
        {
            window.gtag('event', strEvent);
        }
    }
    
    onShareTestimonial()
    {
        this.closeTutorial();
        this.hideItemWhenShowingShareTestimonial();
    }
    
    onIntroStep(options)
    {
        let step = options.step + 1;
        
        if (step > 4)
        {
            step = 4;
        }
        
        let diff = options.step - options.previousStep;
        
        if (diff < 2)
        {
            this.audioManager.playSound(`VM_B_${step}_`);
        }
        
        if (step === 1 && (!options.isContinue))
        {
            setTimeout(() => this.audioManager.playSound("INTRO"), 4000);
        }
    }
    
    onIntroComplete(options)
    {
        console.log("onIntroComplete", options);
        this.audioManager.setVars("intro_complete", true);
        
        if (!options.fromClick)
        {
            this.audioManager.playSound("INTRO_COMPLETE");
            this.audioManager.playSound("VM_O_", true, "AMBIANCE", 2000);
        }
        else
        {
            this.audioManager.playSound("VM_O_", true, "AMBIANCE", 4000, 4000);
        }
        
        this.sendInitialThemes();
        this.broadcast(BusEvent.EVENTS.ON_GET_VISITED_THEMES, {visitedThemes: this.state.visitedThemes});
        
    }
    
    onTestimonialClosed()
    {
        let list = _.shuffle(["VM_F_3A_", "VM_F_3B_", "VM_F_3C_", , "VM_F_3D_",  "VM_F_3E_"]);
        let key = list[0];
        this.playSound(key, false, "CLOSE")
    }
    
    onSetLang(event)
    {
        this.lang = event.options.lang;
        this.langIsSet = true;
        
        if (this.isReady) //we can receive lang BEFORE the project is ready.
        {
            event.options.rebroadcast = false;
            this.broadcast(event);
        }
        
    }
    
    sendInitialThemes()
    {
        let themes = this.getCurrentThemesByName();
        let expectedMiddle = this.objExpectedMiddle = this.expectedMiddle(themes);
        
        this.broadcast(BusEvent.EVENTS.OTHER_THEMES_REQUESTED, {
            rebroadcast: false,
            themes,
            expectedMiddle,
            startUp:     true,
        })
        
        this.onUpdatePrevNextButton("");
        this.broadcast(BusEvent.EVENTS.SHARE_TESTIMONIAL_VISIBILITY, {
            visibility:  this.state.hasAskedToShared ?? false,
            rebroadcast: false
        });
    }
    
    onGetVisitedThemes()
    {
        let themes = JSON.stringify(this.state.visitedThemes);
        this.broadcast(BusEvent.EVENTS.ON_GET_VISITED_THEMES, {visitedThemes: this.state.visitedThemes});
        this.broadcast(BusEvent.EVENTS.THEMES_SELECTION_DISPLAYED, {visibility: false});
        //this.broadcast( BusEvent.EVENTS.SHARE_TESTIMONIAL_VISIBILITY, { visibility : this.state.hasAskedToShared ?? false, rebroadcast : false } );
    }
    
    onPaperReturnedToVortex()
    {
        let themesRemainingCount = this.sessionState.currentGroup.length;
        let visitedCount = this.state.visitedThemes.length;
        
        if (this.hasExperienceEnded())
        {
            this.doSendShowShareTestimony(true);
            return;
            
        }
        
        if (this.listeningToPaperReturnedToVortex)
        {
            let showButton = !this.hasExperienceEnded();
            let options = {
                visibility: showButton && !this.testimonialActive,
                label:      themesRemainingCount > 0 ? "general.other_themes" : "testimonial.end_now",
                action:     themesRemainingCount > 0 ? "themes" : "end"
            };
            this.broadcast(BusEvent.EVENTS.OTHER_THEMES_VISIBILITY, options);
        }
        
    }
    
    hasExperienceEnded()
    {
        let themesCount = this.data.themes.length;
        let visitedCount = this.state.visitedThemes.length;
        
        if (themesCount === visitedCount)
        {
            let viewedCount = this.state.currentTheme.viewTestimonial;
            let totalCount = this.state.currentTheme.totalTestimonial;
            
            if (viewedCount >= totalCount) //we have reached the last testimonial from the last theme
            {
                return true;
            }
        }
        
        return false;
    }
    
    onLaunchTutorial(options)
    {
        this.broadcast(BusEvent.EVENTS.TUTORIAL_EVENT, options)
    }
    
    onVortexReady(event)
    {
        console.log("Bus.onVortexReady", event);
        
        if (this.state.visitedTestimonals.length === 0)
        {
            setTimeout(() => this.prepareTutorial(TUTORIAL_EVENTS.CHOOSE_VORTEX), 10);
        }
        
        //Now we always display the other themes button
        //if (this.strContext === Bus.CONTEXT.BREADCRUMBS_CLICK)
        {
            this.strContext = "";
    
            let themesRemainingCount = this.sessionState.currentGroup.length;
           // let showButton = !this.hasExperienceEnded();
            
            let options = {
                visibility: !this.hasExperienceEnded(),
                label:      themesRemainingCount > 0 ? "general.other_themes" : "testimonial.end_now",
                action:     themesRemainingCount > 0 ? "themes" : "end"
            };
            this.broadcast(BusEvent.EVENTS.OTHER_THEMES_VISIBILITY, options);
            
        }
    }
    
    prepareTutorial(event)
    {
        if (event === TUTORIAL_EVENTS.CHOOSE_VORTEX && !this.state.objTutorialShown.themes)
        {
            let objBroadcast = {};
            objBroadcast.event = BusEvent.EVENTS.TUTORIAL_EVENT;
            objBroadcast.options = {
                type:       TUTORIAL_EVENTS.CHOOSE_VORTEX,
                layoutMode: "center",
            };
            
            this.once(BusEvent.EVENTS.ON_STATUES_RECT_BOUNDS, (event) => this.onPrepareTutorial(event, objBroadcast));
            this.broadcast(BusEvent.EVENTS.GET_STATUES_RECT_BOUNDS, {});
        }
        else if (event === TUTORIAL_EVENTS.CHOOSE_INITIAL_THEME && !this.state.objTutorialShown.testimonial)
        {
            let objBroadcast = {};
            objBroadcast.event = BusEvent.EVENTS.TUTORIAL_EVENT;
            objBroadcast.options = {
                type:       TUTORIAL_EVENTS.CHOOSE_INITIAL_THEME,
                layoutMode: "center",
            };
            
            this.once(BusEvent.EVENTS.ON_STATUES_RECT_BOUNDS, (event) => this.onPrepareTutorial(event, objBroadcast));
            this.broadcast(BusEvent.EVENTS.GET_STATUES_RECT_BOUNDS, {});
        }
    }
    
    onPrepareTutorial(event, obj)
    {
        if (TUTORIAL_EVENTS.CHOOSE_INITIAL_THEME === obj.options.type)
        {
            let rectBounds = event.options.rectBounds;
            
            /*let middleStatue = rectBounds[(rectBounds.length / 2 >> 0)];
             
             let x = middleStatue.x + middleStatue.w / 2;
             let y = middleStatue.y + middleStatue.h / 2;
             
             obj.options.highlightX = x - 45; //offset de 45 pour centrer le highlight
             obj.options.highlightY = y - 45; //offset de 45 pour centrer le highlight*/
            
            
            let highlights = [];
            
            for (let i = 1; i < rectBounds.length - 1; i++)
            {
                let statue = rectBounds[i];
                
                let x = statue.x + statue.w / 2;
                let y = statue.y + statue.h / 2;
                
                let pos = {x, y};
                
                highlights.push(pos);
            }
            
            obj.options.highlights = highlights;
            
            // var elemDiv = document.createElement('div');
            // elemDiv.style.cssText = `position:absolute;width:${middleStatue.w}px;height:${middleStatue.h}px;top:${middleStatue.y}px;left:${middleStatue.x}px;opacity:0.3;z-index:100;background:#000;`;
            // document.body.appendChild(elemDiv);
            //
            // var circleDiv = document.createElement('div');
            // circleDiv.style.cssText = `position:absolute;width:20px;height:20px;top:${y}px;left:${x}px;opacity:0.3;z-index:200;background:#990000;`;
            // document.body.appendChild(circleDiv);
        }
        else if (TUTORIAL_EVENTS.CHOOSE_VORTEX === obj.options.type)
        {
            let rectBounds = event.options.rectBounds;
            
            let middleStatue = rectBounds[(rectBounds.length / 2 >> 0)];
            
            let x = middleStatue.x + middleStatue.w / 2;
            let y = middleStatue.y + middleStatue.h / 2;
            
            let pos = {x, y};
            
            let highlights = [];
            highlights.push(pos);
            
            obj.options.highlights = highlights;
            // obj.options.highlightX = x - 45; //offset de 45 pour centrer le highlight
            // obj.options.highlightY = y - 45; //offset de 45 pour centrer le highlight
            
        }
        
        this.setTutorialAsShown(obj.options.type)
        this.broadcast(BusEvent.EVENTS.TUTORIAL_EVENT, obj.options);
        
    }
    
    setTutorialAsShown(type)
    {
        let lut = {};
        lut[TUTORIAL_EVENTS.CHOOSE_VORTEX] = "themes";
        lut[TUTORIAL_EVENTS.CHOOSE_INITIAL_THEME] = "testimonial";
        lut[TUTORIAL_EVENTS.RECORD_TESTIMONIAL] = "share_testimonial";
        lut[TUTORIAL_EVENTS.BREADCRUMBS_THEMES] = "breadcrumbs";
        
        let strType = lut[type];
        
        if (strType)
        {
            this.state.objTutorialShown[strType] = true;
            this.saveState();
        }
    }
    
    once(event, callback)
    {
        this.arrOnce.push({event, callback});
    }
    
    onNewThemeShown()
    {
        let options = {visibility: true};
        this.broadcast(BusEvent.EVENTS.BREADCRUMB_VISIBILITY, options);
        this.broadcast(BusEvent.EVENTS.THEMES_SELECTION_DISPLAYED, options);
        this.broadcast(BusEvent.EVENTS.SHARE_TESTIMONIAL_VISIBILITY, {
            visibility:  this.state.hasAskedToShared ?? false,
            rebroadcast: false
        });
        
        if (this.state.visitedThemes.length === 0)
        {
            
            
            setTimeout(() => this.prepareTutorial(TUTORIAL_EVENTS.CHOOSE_INITIAL_THEME), 10);
            
            
            
        }
        else if (this.state.visitedThemes.length === 1 && !this.state.objTutorialShown.breadcrumbs)
        {
            
            let objBroadcast = {};
            objBroadcast.event = BusEvent.EVENTS.TUTORIAL_EVENT;
            objBroadcast.options = {
                type:       TUTORIAL_EVENTS.BREADCRUMBS_THEMES,
                layoutMode: "top-right-of",
            };
            
            setTimeout(this.broadcastDelay.bind(this, objBroadcast, () =>
            {
                this.state.objTutorialShown.breadcrumbs = true;
                this.saveState();
            }), 1000);
            
            //this.broadcast(BusEvent.EVENTS.GET_STATUES_RECT_BOUNDS, {});
        }
        
        let list = _.shuffle(["VM_C_1A_", "VM_C_1B_", "VM_C_1C_"]);
        let key = list[0];
    
        this.playSound("VM_P_", true, "AMB_PAPER");
        this.playSound(key);
        
    }
    
    broadcastDelay(obj, callback = null)
    {
        this.broadcast(obj.event, obj.options);
        
        if (callback)
        {
            callback();
        }
    }
    
    getLatestTestimonialFromCurrentTheme()
    {
        
        let theme = this.data.themes.find(t => t.id === this.state.currentTheme.id);
        
        
        //remove first, push it back
        let testimonial = theme.testimonials.shift();
        testimonial.view = true;
        theme.testimonials.push(testimonial)
        
        
        return testimonial;
    }
    
    onTestimonialIsReadyToBeDisplayed(event)
    {
        
        if (this.testimonialActive) //we want to avoid having multiple testimonial at once
            return;
        
        this.testimonialActive = true;
        
        let testimonial = this.nextTestimonial = this.getLatestTestimonialFromCurrentTheme();
    
       
        if (testimonial.type !== "text_and_image")
        {
            this.muteSound(-1, 0, "AMBIANCE", 6000)
            this.muteSound(-1, 0, "AMB_PAPER", 6000)
        }
        
        
        
        this.state.visitedTestimonals.push(testimonial.id)
        this.state.currentTheme.viewTestimonial += 1;
        this.saveState();
        
    
        let theme = this.data.themes.find(t => t.id === this.state.currentTheme.id);
    
        theme.testimonials = theme.testimonials.filter( t => t.langs.includes(this.lang))
        let countTestimonial = theme.testimonials.length;
        let countTestimonialView = theme.testimonials.filter ( t => t.view).length;
        
        testimonial = {...testimonial};
        testimonial.nav =
        {
            themeTitle: this.state.currentTheme.title[this.lang],
            countTestimonial,
            countTestimonialView
        };
    
        this.broadcast(new BusEvent(BusEvent.EVENTS.TESTIMONIAL_READY_TO_SLIDE_IN, {
            theme: this.state.currentTheme.id,
            testimonial,
        }))
        
        this.sendGtagEvent("Testimonial", testimonial.title[this.lang]);
        
    }
    
    
    onTestimonialIsOffscreen(event)
    {
        this.testimonialActive = false;
        
        if (this.reachLastTestimonial())
        {
            
            if (!this.listeningToPaperReturnedToVortex)
            {
                this.listeningToPaperReturnedToVortex = true;
            }
            
            if (this.hasExperienceEnded())
            {
                let options = {visibility: false};
                this.broadcast(BusEvent.EVENTS.OTHER_THEMES_VISIBILITY, options);
            }
            
        }
        
        let options = this.getCurrentThemeInfo();
        this.broadcast(BusEvent.EVENTS.RETURN_PAPER_TO_VORTEX, options);
        
        if (this.nextTestimonial.type !== "text_and_image")
        {
            this.unmuteSound(-1, 0, "AMBIANCE", 2000)
            this.unmuteSound(-1, 0, "AMB_PAPER", 1000)
        }
        
        // let list = _.shuffle(["VM_F_3A_"/*,"VM_F_3B_", "VM_F_3C_", "VM_F_3D_", "VM_F_3E_"*/]);
        // let key = list[0];
        //
        // this.playSound(key);
    }
    
    expectedMiddle(themes)
    {
        if (themes.length === 0)
        {
            return {id: -1, index: 0};
        }
        
        let iMiddle = themes.length % 2 === 0 ? (themes.length / 2) : (themes.length - 1) / 2;
        
        let theme = themes[iMiddle];
        
        return {id: theme.id, index: iMiddle};
    }
    
    onShowNewThemes()
    {
        this.prepareCurrentGroup();
        
        let themes = this.getCurrentThemesByName();
        let expectedMiddle = this.objExpectedMiddle = (themes.length > 0 ? this.expectedMiddle(themes) : {});
        
        
        //this.broadcast(BusEvent.EVENTS.OTHER_THEMES_REQUESTED, {themes: this.sessionState.currentGroup})
        this.closeTutorial();
        this.broadcast(BusEvent.EVENTS.OTHER_THEMES_REQUESTED, {rebroadcast: false, themes, expectedMiddle})
        this.broadcast(BusEvent.EVENTS.OTHER_THEMES_VISIBILITY, {visibility: false, rebroadcast: false});
        this.broadcast(BusEvent.EVENTS.SHARE_TESTIMONIAL_VISIBILITY, {
            visibility:  this.state.hasAskedToShared ?? false,
            rebroadcast: false
        });
        
        this.onUpdatePrevNextButton("");
        
        
        if (this.state.visitedThemes.length >= 2 && this.state.visitedTestimonals.length >= 5 && !this.state.hasAskedToShared)
        {
            //FOR NOW WE USE TIME BUT WE SHOULD WAIT FOR THE EVENT - NEW_THEMES_SHOWN
            
            this.fctDoSendShowShareTestimony = this.doSendShowShareTestimony.bind(this);
            document.addEventListener(BusEvent.EVENTS.NEW_THEMES_SHOWN, this.fctDoSendShowShareTestimony);
            
            //setTimeout (  this.fctDoSendShowShareTestimony, 6000 ); //REMOVE THIS WHEN NEW_THEMES_SHOWN is emitted
            this.state.hasAskedToShared = true;
            this.saveState();
            
            this.broadcast(BusEvent.EVENTS.ENABLE_DISABLE_PREV_NEXT_BUTTON, {
                prev:       false,
                next:       false,
                hideButton: true,
                
            });
        }
        
        this.audioManager.stopSound(null, "VM_Q_1_", 1000);
        let list = _.shuffle(["VM_G_2A1_", "VM_G_2B1_", "VM_G_2C1_"]);
        let key = list[0];
        
        this.playSound(key);
        
    }
    
    
    onStartFinishExperience()
    {
        this.isFinished = true;
        let options = {visibility: false};
        
        // this.hidePrevNextButton();
        // this.broadcast(BusEvent.EVENTS.BREADCRUMB_VISIBILITY, options);
        // this.broadcast(BusEvent.EVENTS.THEMES_SELECTION_DISPLAYED, options);
        // this.broadcast(BusEvent.EVENTS.SHARE_TESTIMONIAL_VISIBILITY, options);
        
        this.broadcast(BusEvent.EVENTS.SHOW_END_VORTEX);
        
        this.hideItemWhenShowingShareTestimonial();
        
        this.playSound("VM_I_2_", false, "I");
        this.playSound("VM_L_1_", false, "L");
        
        setTimeout(() => this.playSound("VM_M_"), 3000);
        
        
    }
    
    
    onShareTestimonialVisibility(e)
    {
        
        if (e.options.visibility)
        {
            if (this.hasExperienceEnded())
            {
                this.onStartFinishExperience();
            }
            else if (!this.state.objTutorialShown.share_testimonial)
            {
                this.broadcast(BusEvent.EVENTS.SHOW_VORTEX)
                
                let objBroadcast = {};
                objBroadcast.event = BusEvent.EVENTS.TUTORIAL_EVENT;
                objBroadcast.options = {
                    type:       TUTORIAL_EVENTS.RECORD_TESTIMONIAL,
                    layoutMode: "top-left-of",
                };
                
                setTimeout(this.broadcastDelay.bind(this, objBroadcast, () =>
                {
                    this.state.objTutorialShown.share_testimonial = true;
                    this.saveState();
                }), 500)
            }
        }
    }
    
    onShowCredits()
    {
        //this.broadcast(BusEvent.EVENTS.SEND_TO_CREDITS); //old event
        console.log("onShowCredts");
        this.broadcast(BusEvent.EVENTS.OUTRO_START_TEXT); //new event
    }
    
    doSendShowShareTestimony(last = false)
    {
        document.removeEventListener(BusEvent.EVENTS.NEW_THEMES_SHOWN, this.fctDoSendShowShareTestimony);
        this.hideItemWhenShowingShareTestimonial(last);
    }
    
    hideItemWhenShowingShareTestimonial(last = false)
    {
        this.broadcast(BusEvent.EVENTS.SHARE_TESTIMONIAL, {rebroadcast: false, visibility: true})
        this.broadcast(BusEvent.EVENTS.HIDE_VORTEX, {rebroadcast: false, last})
        this.broadcast(BusEvent.EVENTS.BREADCRUMB_VISIBILITY, {rebroadcast: false, visibility: false});
        this.broadcast(BusEvent.EVENTS.OTHER_THEMES_VISIBILITY, {rebroadcast: false, visibility: false});
        
        this.hidePrevNextButton();
        this.closeTutorial();
    }
    
    
    reachLastTestimonial()
    {
        
        return true;
    }
    
    getDefaultState()
    {
        return {
            visitedThemes:      [],
            visitedTestimonals: [],
            currentTheme:       {},
            hasAskedToShared:   false,
            objTutorialShown:   {themes: false, breadcrumbs: false, share_testimonial: false, testimonial: false},
        }
    }
    
    getCurrentThemeInfo()
    {
        
        return {
            views:   this.state.currentTheme.viewTestimonial,
            total:   this.state.currentTheme.totalTestimonial,
            percent: this.state.currentTheme.viewTestimonial / this.state.currentTheme.totalTestimonial,
        }
    }
    
    prepareState()
    {
        let stateExist = false;
        if (!window.localStorage)
        {
            this.state = this.getDefaultState();
        }
        else
        {
            let state = window.localStorage.getItem("vimy");
            
            stateExist = state ? true : false; //state is a string, but we really want stateExist to be a boolean
            
            this.state = state ? JSON.parse(state) : this.getDefaultState();
            
        }
        
        this.prepareThemes();
        this.prepareTestimonials();
        
        this.prepareSession();
        
    }
    
    prepareThemes()
    {
        let currentlySeenTheme = this.state.themes?.visited ?? [];
        
        let themes = (this.data.themes ?? []) //randomize theme
             .map(t => ({t, order: Math.random()}))
            // .sort((a, b) =>
            //       {
            //           return a.order - b.order;
            //       })
            .map(t => t.t);
        
        //********* TEMP ********************
        //For now we want to force, Grief to be in the first group
        // let index = themes.findIndex( t => t.id === 1);
        //
        // if (index > 2)
        // {
        //     let theme = themes.splice(index, 1)[0];
        //     themes.splice(1, 0, theme); //we place it a index 1, so it will be place in the middle
        // }
        
        console.log("HASH", window.location.hash);
        
        this.data.themes = themes;
        
    }
    
    prepareTestimonials(maxTestimonials = -1)
    {
        this.data.themes.forEach(theme => this.prepareTestimonial(theme, maxTestimonials));
    }
    
    prepareTestimonial(theme, maxTestimonials = 1)
    {
        // if (theme.id === 1) //hardcoding values for theme 1, remove after presentation
        // {
        //     let arrIdToKeep = [3,8,6,9,10,7,11,12];
        //
        //
        //     theme.testimonials = Object.values(theme.testimonials)
        //                                 .filter ( t => arrIdToKeep.includes(t.id))
        //                                 .sort( (a,b) => arrIdToKeep.indexOf(a.id) - arrIdToKeep.indexOf(b.id))
        // }
        // else
        {
            theme.testimonials = Object.values(theme.testimonials)
                                       .map(t => ({t, order: Math.random()}))
                                       .sort((a, b) => a.order - b.order)
                                       .map(t => t.t);
            
            if (maxTestimonials > 0)
            {
                theme.testimonials = theme.testimonials.splice(0, maxTestimonials);
            }
        }
        
    }
    
    
    prepareSession()
    {
        this.prepareCurrentGroup();
    }
    
    prepareCurrentGroup()
    {
        let visited = this.state.visitedThemes;
        
        let themeInGroup = this.data.themes.map(t => t.id)
                               .filter(t => !visited.includes(t))
                               .map(t => ({t, order: Math.random()})) //prepare randomize
            //.sort ( (a,b) => a.order - b.order) //sort randomize
                               .map(t => t.t);
        //.slice(0, Math.min(3, this.data.themes.length - visited.length)); //in the end, we only the remaining themes
        
        
        // if (visited.length === 0)
        // {
        //     //for demo, we want id 1 to be there at the start
        //     if (!themeInGroup.find(t => t === 1))
        //     {
        //         let theme1 = this.data.themes.find( t => t.id === 1);
        //         themeInGroup.pop();
        //         themeInGroup.splice(1,0, theme1.id);
        //     }
        // }
        
        
        this.sessionState.currentGroup = themeInGroup;
        
        
    }
    
    
    onHover3D(event)
    {
        
        if (event.options.target === "vortex")
        {
            this.audioManager.changeRate("VM_Q_1_", 1, 0.25, 1);
            this.bChangedRate = true;
        }
        else if (this.bChangedRate && event.options.target === null)
        {
            this.audioManager.changeRate("VM_Q_1_", 0.25, 1, 1);
        }
        
        document.body.style.cursor = event.options.target ? "pointer" : "default";
    }
    
    onClick3D(event)
    {
        console.log("onClick3D", event);
        
        this.playSound("VM_D_1_");
        
        this.closeTutorial()
        
        if (event.options.target === "vortex")
        {
            
            
            this.broadcast(BusEvent.EVENTS.OTHER_THEMES_VISIBILITY, {visibility: false})
            
            let list = _.shuffle(["VM_E_2A_", "VM_E_2B_", "VM_E_2C_", "VM_E_2D_", "VM_E_2E_"]);
            let key = list[0];
            
            this.playSound(key);
            
           
        }
        else
        {
            let list = _.shuffle(["VM_D_2A1_", "VM_D_2A2_", "VM_D_2B1_", "VM_D_2B2_", "VM_D_2C1_", "VM_D_2C2_"]);
            let key = list[0];
            
            this.playSound(key);
            this.audioManager.stopAllGroup(null, "AMB_PAPER", 1000);
            this.audioManager.playSound("VM_Q_1_", true, "AMB_PAPER");
        }
        
        
        //document.body.style.cursor = event.options.target ? "pointer": "default";
    }
    
    closeTutorial()
    {
        this.broadcast(BusEvent.EVENTS.TUTORIAL_EVENT, {type: TUTORIAL_EVENTS.CLOSE_TUTORIAL});
        this.bTutorialShown = false;
    }
    
    saveState()
    {
        if (window.localStorage)
        {
            let strState = JSON.stringify(this.state);
            
            window.localStorage.setItem("vimy", strState);
        }
        
        
    }
    
    
    onShowPrevNextTheme(event)
    {
        if (this.sessionState.currentGroup.length === 0)
        {
            this.broadcast(BusEvent.EVENTS.ENABLE_DISABLE_PREV_NEXT_BUTTON, {
                prev:       false,
                next:       false,
                hideButton: true,
            });
            return;
        }
        
        event.options.expectedMiddle = this.objExpectedMiddle = this.moveExpectedMiddle(event);
        
        this.broadcast(event);
        
        let strDir = event.options.direction;
        
        this.onUpdatePrevNextButton(strDir);
        
        
    }
    
    onUpdatePrevNextButton(strDir)
    {
        let disablePrev = (/*strDir === "prev" && */this.objExpectedMiddle.index <= 1);
        let disableNext = (/*strDir === "next" && */this.objExpectedMiddle.index >= this.sessionState.currentGroup.length - 2);
        
        this.broadcast(BusEvent.EVENTS.ENABLE_DISABLE_PREV_NEXT_BUTTON, {
            prev:       !disablePrev,
            next:       !disableNext,
            hideButton: this.sessionState.currentGroup.length <= 3,
        });
    }
    
    hidePrevNextButton ()
    {
        this.broadcast(BusEvent.EVENTS.ENABLE_DISABLE_PREV_NEXT_BUTTON, {
            prev:       false,
            next:       false,
            hideButton: true,
        });
    }
    
    
    onGetPrevNextTheme()
    {
        this.onUpdatePrevNextButton("");
    }
    
    moveExpectedMiddle(event)
    {
        let strDir = event.options.direction;
        let index = this.objExpectedMiddle.index;
        
        if (strDir === "prev")
        {
            index = Math.max(index - 1, 0)
        }
        else if (strDir === "next")
        {
            index = Math.min(index + 1, this.sessionState.currentGroup.length - 1)
        }
        
        let id = this.sessionState.currentGroup[index];
        
        return {index, id}
    }
    
    onShareTestimonialClosed()
    {
        if (this.isFinished)
            return;
        
        this.broadcast(BusEvent.EVENTS.BREADCRUMB_VISIBILITY, {visibility: true})
        this.broadcast(BusEvent.EVENTS.THEMES_SELECTION_DISPLAYED, {visibility: true})
        this.broadcast(BusEvent.EVENTS.SHOW_VORTEX, {visibility: true})
        this.onUpdatePrevNextButton("");
        this.playSound("VM_H_2_");
    }
    
    setMaxThemes(count)
    {
        let visitedThemes = this.data.themes.slice(count);
        this.state.visitedThemes = visitedThemes.map(t => t.id);
        this.broadcast(BusEvent.EVENTS.ON_GET_VISITED_THEMES, {visitedThemes: this.state.visitedThemes});
        
        
        this.prepareCurrentGroup();
        
        return count;
        
    }
    
    setMaxTestimonials(count)
    {
        this.prepareTestimonials(count);
        
        return count;
    }
    
    
}

//Poor man singleton!
const __bus__ = new Bus();
window.__BUS__ = __bus__;